import { Suspense, useEffect } from "react";
import { usePathname } from "expo-router";
import { BrainIcon, Button, ChatDialog } from "@ptsd/uikit";
import { useDialogContext } from "@ptsd/uikit/src/stories/features/chat-ui/dialog";
import { Circle, useWindowDimensions } from "tamagui";

import { api } from "~/utils/api";
import { ChatHolder } from "~/component/feature/chat-bot/chat-holder";

const MAIN_CONTENT_MAX_WIDTH_PX = 1200;

const getXPositionOfDialogTrigger = (
  width: number,
  mainContentMaxWidth: number,
  offsetX = 21,
  btnWidth = 64,
) => {
  if (width > mainContentMaxWidth) {
    return (width - mainContentMaxWidth) / 2 + mainContentMaxWidth + offsetX;
  }
  return width - (offsetX + btnWidth);
};

const ChatBotWrapper = () => {
  const { open } = useDialogContext();
  if (!open) {
    return null;
  }

  return (
    <Suspense>
      <ChatHolder />
    </Suspense>
  );
};

export const ChatBotDialog = () => {
  const { width } = useWindowDimensions();
  const { data, refetch, isFetched } = api.chat.status.useQuery(undefined, {
    refetchInterval: (data) => {
      if (data?.isAvailable === false) {
        return false;
      }

      if (data?.isReady === false) {
        return 1000;
      }

      return false;
    },
  });

  const pathname = usePathname();

  useEffect(() => {
    if (pathname.startsWith("/results/hmt")) {
      void refetch();
    }
  }, [pathname, refetch]);

  if (!isFetched) {
    return;
  }

  if (data?.isAvailable === false) {
    return;
  }

  if (data?.isReady === false) {
    //TODO: should we make some loader?
    return;
  }

  return (
    <ChatDialog.Dialog>
      <ChatDialog.Trigger asChild>
        <Button
          zIndex={1000}
          borderRadius={999}
          shadowColor="#000"
          shadowOffset={{ width: 0, height: 20 }}
          shadowOpacity={0.1}
          shadowRadius={25}
          position="absolute"
          bottom={"$3.5"}
          x={getXPositionOfDialogTrigger(width, MAIN_CONTENT_MAX_WIDTH_PX)}
          unstyled
        >
          {/*<Circle
            position="absolute"
            backgroundColor={"$error-500"}
            width={"$2.5"}
            height={"$2.5"}
            top={-6}
            right={-4}
            zIndex={50}
          >
            <Text
              fontFamily={"$subtitle"}
              fontWeight={"$4"}
              fontSize={"$2"}
              lineHeight={"$2"}
              color={"white"}
              position="absolute"
            >
              1
            </Text>
          </Circle>*/}
          <Circle
            alignItems="center"
            justifyContent="center"
            width={"$8"}
            backgroundColor={"$pinkmain-500"}
            height={"$8"}
            shadowColor="#000"
            shadowOffset={{ width: 0, height: 8 }}
            shadowOpacity={0.1}
            shadowRadius={10}
          >
            <BrainIcon />
          </Circle>
        </Button>
      </ChatDialog.Trigger>
      <ChatDialog.Portal>
        <ChatDialog.Overlay
          style={{
            backgroundColor: "#23252A33",
          }}
        />
        <ChatBotWrapper />
      </ChatDialog.Portal>
    </ChatDialog.Dialog>
  );
};
